import { uid, insertCSS, debounce } from "utils";

export default function revealContent(config = {}) {

  const { targetClass, displayHeight, resetOnResize = false, bgColor = "white" } = config;

  if (!displayHeight) return;

  applyStyles(bgColor);

  let reveals = collectItems();

  function collectItems(collection = {}) {
    Array.from(document.querySelectorAll(targetClass)).forEach(item => {
      const id = uid();
      const scroll = item.scrollHeight;
      if (scroll > displayHeight) {

        const openButton = createElement("button", {
          klass: "reveal-content-open active",
          reveal: id,
          content: "•••"
        });

        const closeButton = createElement("button", {
          klass: "reveal-content-close",
          reveal: id,
          content: "×"
        });

        item.style.position = "relative";
        item.style.overflow = "hidden";
        item.style.height = `${displayHeight}px`;
        item.style.transition = "height .3s ease";
        item.appendChild(openButton);
        item.appendChild(closeButton);
        collection[id] = {
          ref: item,
          open: openButton,
          close: closeButton,
          initHeight: item.offsetHeight,
        };
      }
    });
    return collection;
  }

  if (resetOnResize) {
    window.addEventListener("resize", debounce(reset, 400));
  }

  document.addEventListener("click", event => {
    if (event.target.dataset && event.target.dataset.reveal) {
      const reveal = reveals[event.target.dataset.reveal];
      if (event.target.matches("button.reveal-content-open")) {
        reveal.ref.style.height = `${reveal.ref.scrollHeight + 20}px`;
        reveal.open.classList.remove("active");
        reveal.close.classList.add("active");
        reveal.open.blur();
      } else if (event.target.matches("button.reveal-content-close")) {
        reveal.ref.style.height = `${displayHeight}px`;
        reveal.open.classList.add("active");
        reveal.close.classList.remove("active");
        reveal.close.blur();
      }
    }
  });

  function reset() {
    Object.keys(reveals).forEach(key => {
      const reveal = reveals[key];
      reveal.open.remove();
      reveal.close.remove();
      reveal.ref.style.height = "auto";
      delete reveal[key];
    });
    reveals = collectItems(reveals);
  }

  function getReveals() {
    return Object.values(reveals).map(r => r.ref);
  }

  return {
    reset,
    getReveals,
  };
}

// ---- Helper ----------------

function createElement(type, config = {}) {
  const { klass, reveal, content } = config;
  const element = document.createElement(type);

  if (klass) {
    element.className = klass;
  }

  if (reveal) {
    element.dataset.reveal = reveal;
  }

  if (content) {
    element.innerHTML = content;
  }

  return element;
}

// ---- Styles ----------------

function applyStyles(color) {
  insertCSS(`
    button.reveal-content-open.active,
    button.reveal-content-close.active {
      right: 0;
    }

    button.reveal-content-open {
      padding: 11px 0 0 40px;
      line-height: 9px;
    }

    button.reveal-content-close {
      padding: 0 0 0 40px;
    }

    button.reveal-content-open,
    button.reveal-content-close {
      margin: 0;
      bottom: 0;
      right: -60px;
      outline: none;
      display: block;
      color: inherit;
      user-select: none;
      position: absolute;
      transition: right 0.3s ease;
      background: linear-gradient(to right, rgba(255,255,255,0) 0%, ${color} 70%);
    };
  `);
};